/* APPEL Active — theme.js (no dependencies) */
(function () {
  'use strict';

  var T = window.theme || {};
  var body = document.body;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(T.locale || 'ja', { style: 'currency', currency: T.currency || 'JPY' }).format(cents / 100);
    } catch (e) {
      return String(cents / 100);
    }
  }

  function lockScroll(lock) { body.classList.toggle('is-locked', !!lock); }

  /* ---------- mobile menu ---------- */
  var menu = $('[data-menu-drawer]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    lockScroll(open);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); setMenu(true); }
    else if (e.target.closest('[data-menu-close]')) { setMenu(false); }
  });

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    lockScroll(open);
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('data-empty'); else el.setAttribute('data-empty', '');
    });
    $$('[data-cart-count-inline]').forEach(function (el) { el.textContent = count; });
  }

  function refreshCart() {
    var url = (T.routes && T.routes.root ? T.routes.root : '/') + '?sections=cart-drawer';
    return Promise.all([
      fetch(url).then(function (r) { return r.json(); }),
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var html = res[0]['cart-drawer'];
      var cart = res[1];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawerInner');
        var current = document.getElementById('CartDrawerInner');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
      updateCount(cart.item_count);
      return cart;
    });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && drawer && document.body.className.indexOf('template-cart') === -1) {
      e.preventDefault();
      refreshCart().then(function () { setDrawer(true); });
      return;
    }
    if (e.target.closest('[data-cart-close]')) { setDrawer(false); return; }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      drawer.classList.add('is-loading');
      fetch((T.routes && T.routes.cartChange) || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(qtyBtn.dataset.line), quantity: Number(qtyBtn.dataset.qty) })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .catch(function () {})
        .then(function () { drawer.classList.remove('is-loading'); });
    }
  });

  /* ---------- added-to-cart popup ---------- */
  var pop = $('[data-added-pop]');
  function setPop(open, item) {
    if (!pop) return;
    if (open && item) {
      var img = $('[data-added-img]', pop);
      if (img) {
        var src = item.featured_image && item.featured_image.url || item.image;
        if (src) { img.src = src; img.hidden = false; } else { img.hidden = true; }
      }
      var t = $('[data-added-title]', pop);
      if (t) t.textContent = item.product_title || item.title || '';
      var v = $('[data-added-variant]', pop);
      if (v) v.textContent = item.variant_title || '';
    }
    pop.classList.toggle('is-open', open);
    pop.setAttribute('aria-hidden', open ? 'false' : 'true');
    lockScroll(open);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-added-close]')) setPop(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setDrawer(false); setPop(false); setMenu(false); }
  });

  /* ---------- add to cart (ajax) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var btn = $('[data-add-btn]', form);
    var errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    if (btn) btn.setAttribute('disabled', '');

    var fd = new FormData(form);
    var added = null;
    fetch((T.routes && T.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json && (res.json.description || res.json.message));
        added = res.json;
        return refreshCart();
      })
      .then(function () { if (pop) setPop(true, added); else setDrawer(true); })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = (err && err.message) || (T.strings && T.strings.error) || 'Error';
          errorEl.hidden = false;
        }
      })
      .then(function () { if (btn) btn.removeAttribute('disabled'); });
  });

  /* ---------- quantity stepper (product page) ---------- */
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-dec]');
    var inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    var input = $('input[name="quantity"]', (dec || inc).parentNode);
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (inc ? 1 : -1));
  });

  /* ---------- product variants ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var idInput = $('[data-variant-id]', root);
    var btn = $('[data-add-btn]', root);
    var label = $('[data-add-label]', root);
    var priceWrap = $('[data-price-wrap]', root);
    var fieldsets = $$('[data-option]', root);
    var strings = T.strings || {};

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
    }

    function priceHTML(v) {
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var html = '<div class="price' + (onSale ? ' price--sale' : '') + '" data-price>' +
        '<span class="price__now">' + formatMoney(v.price) + '</span>';
      if (onSale) html += '<s class="price__was">' + formatMoney(v.compare_at_price) + '</s>';
      return html + '</div>';
    }

    function update() {
      if (!fieldsets.length) return;
      var v = findVariant(selectedOptions());
      if (!v) {
        if (btn) btn.setAttribute('disabled', '');
        if (label) label.textContent = strings.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceWrap) priceWrap.innerHTML = priceHTML(v);
      if (btn) {
        if (v.available) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', '');
      }
      if (label) label.textContent = v.available ? strings.add : strings.soldOut;

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      if (v.featured_media && window.matchMedia('(max-width: 989px)').matches) {
        var target = $('[data-media-id="' + v.featured_media.id + '"]', root);
        if (target && target.parentNode) {
          target.parentNode.scrollTo({ left: target.offsetLeft - target.parentNode.offsetLeft, behavior: 'smooth' });
        }
      }
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
  }
  $$('[data-product]').forEach(initProduct);

  /* ---------- collection sort ---------- */
  var sort = $('[data-sort-select]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- login: password recovery toggle ---------- */
  var toggleRecover = $('[data-toggle-recover]');
  if (toggleRecover) {
    toggleRecover.addEventListener('click', function (e) {
      e.preventDefault();
      var box = document.getElementById('recover');
      if (box) box.hidden = !box.hidden;
    });
  }
  if (window.location.hash === '#recover') {
    var rb = document.getElementById('recover');
    if (rb) rb.hidden = false;
  }

  /* ---------- account addresses ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-address-toggle]');
    if (t) {
      e.preventDefault();
      var box = document.getElementById('EditAddress-' + t.dataset.addressToggle);
      if (box) box.hidden = !box.hidden;
      return;
    }
    var d = e.target.closest('[data-address-delete]');
    if (d) {
      e.preventDefault();
      if (window.confirm(d.dataset.confirm || 'Delete?')) {
        var f = document.createElement('form');
        f.method = 'post';
        f.action = '/account/addresses/' + d.dataset.addressDelete;
        f.innerHTML = '<input type="hidden" name="_method" value="delete">';
        document.body.appendChild(f);
        f.submit();
      }
    }
  });
})();
